import { action } from 'typesafe-actions';
import {
  MapActionTypes,
  GeoscapeAddress,
  LandParcelType,
  MapGetPlaceSuggestPayload,
  GeocodeCoordinatePayload,
  HexBinClassBreaks,
  BaseMapOptions
} from 'types';

export const getGeocodeStart = (payload: GeocodeCoordinatePayload) =>
  action(MapActionTypes.GET_GEOCODE_START, payload);
export const getGeocodeSuccess = (payload: any) =>
  action(MapActionTypes.GET_GEOCODE_SUCCESS, payload);
export const getGeocodeFailure = (payload: string) =>
  action(MapActionTypes.GET_GEOCODE_FAILURE, payload);
export const clearGeocode = () => action(MapActionTypes.CLEAR_GEOCODE);

export const getPlaceSuggestStart = (payload: MapGetPlaceSuggestPayload) =>
  action(MapActionTypes.GET_PLACE_SUGGESTION_START, payload);
export const getPlaceSuggestSuccess = (payload: any) =>
  action(MapActionTypes.GET_PLACE_SUGGESTION_SUCCESS, payload);
export const getPlaceSuggestFailure = (payload: any) =>
  action(MapActionTypes.GET_PLACE_SUGGESTION_FAILURE, payload);
export const clearPlaceSuggest = () =>
  action(MapActionTypes.CLEAR_PLACE_SUGGESTION);

export const queryFeatureLayerExtentStart = (
  layer: __esri.FeatureLayer,
  query?: string,
  extent?: __esri.Polygon
) =>
  action(MapActionTypes.QUERY_FEATURE_LAYER_EXTENT_START, {
    layer,
    query,
    extent
  });
export const queryFeatureLayerExtentSuccess = (payload: any) =>
  action(MapActionTypes.QUERY_FEATURE_LAYER_EXTENT_SUCCESS, payload);
export const queryFeatureLayerExtentFailure = (payload: any) =>
  action(MapActionTypes.QUERY_FEATURE_LAYER_EXTENT_FAILURE, payload);
export const clearFeatureLayerLayerExtent = () =>
  action(MapActionTypes.CLEAR_FEATURE_LAYER_EXTENT);

export const queryFeatureLayerFeaturesStart = (
  layer: __esri.FeatureLayer,
  query: any = undefined
) =>
  action(MapActionTypes.QUERY_FEATURE_LAYER_FEATURES_START, { layer, query });
export const queryFeatureLayerFeaturesSuccess = (payload: any) =>
  action(MapActionTypes.QUERY_FEATURE_LAYER_FEATURES_SUCCESS, payload);
export const queryFeatureLayerFeaturesFailure = (payload: any) =>
  action(MapActionTypes.QUERY_FEATURE_LAYER_FEATURES_FAILURE, payload);
export const clearFeatureLayerLayerFeatures = () =>
  action(MapActionTypes.CLEAR_FEATURE_LAYER_FEATURES);

export const getHexBinClassBreakStatisticsStart = (
  layer: __esri.FeatureLayer,
  resolution: number,
  statisticField: string
) =>
  action(MapActionTypes.GET_HEXBIN_CLASS_BREAKS_START, {
    layer,
    resolution,
    statisticField
  });
export const getHexBinClassBreakStatisticsSuccess = (
  payload: HexBinClassBreaks
) => action(MapActionTypes.GET_HEXBIN_CLASS_BREAKS_SUCCESS, payload);
export const getHexBinClassBreakStatisticsFailure = (payload: any) =>
  action(MapActionTypes.GET_HEXBIN_CLASS_BREAKS_FAILURE, payload);

export const getBaseMapsStart = () =>
  action(MapActionTypes.GET_BASE_MAPS_START);
export const getBaseMapsSuccess = (payload: BaseMapOptions) =>
  action(MapActionTypes.GET_BASE_MAPS_SUCCESS, payload);
export const getBaseMapsFailure = (payload: string) =>
  action(MapActionTypes.GET_BASE_MAPS_FAILURE, payload);
export const getPlaceCandidateAddressStart = (payload: any) =>
  action(MapActionTypes.GET_PLACE_ADDRESS_CANDIDATE_START, payload);
export const getPlaceCandidateAddressSuccess = (payload: any) =>
  action(MapActionTypes.GET_PLACE_ADDRESS_CANDIDATE_SUCCESS, payload);
export const getPlaceCandidateAddressFailure = (payload: string) =>
  action(MapActionTypes.GET_PLACE_ADDRESS_CANDIDATE_FAILURE, payload);
export const clearPlaceCandidateAddress = () =>
  action(MapActionTypes.CLEAR_PLACE_ADDRESS_CANDIDATE);
export const getGeoscapeAddressStart = (payload: any) =>
  action(MapActionTypes.GET_GEOSCAPE_ADDRESS_START, payload);
export const getGeoscapeAddressSuccess = (payload: GeoscapeAddress) =>
  action(MapActionTypes.GET_GEOSCAPE_ADDRESS_SUCCESS, payload);
export const getGeoscapeAddressFailure = (payload: string) =>
  action(MapActionTypes.GET_GEOSCAPE_ADDRESS_FAILURE, payload);
export const getGeoscapeLandParcelStart = (payload: any) =>
  action(MapActionTypes.GET_GEOSCAPE_LAND_PARCEL_START, payload);
export const getGeoscapeLandParcelSuccess = (payload: LandParcelType) =>
  action(MapActionTypes.GET_GEOSCAPE_LAND_PARCEL_SUCCESS, payload);
export const getGeoscapeLandParcelFailure = (payload: string) =>
  action(MapActionTypes.GET_GEOSCAPE_LAND_PARCEL_FAILURE, payload);
export const clearGeoscapeAddress = () =>
  action(MapActionTypes.CLEAR_GEOSCAPE_ADDRESS);
export const clearGeoscapeLandParcel = () =>
  action(MapActionTypes.CLEAR_GEOSCAPE_LAND_PARCEL);
export const clearBaseMaps = () => action(MapActionTypes.CLEAR_BASE_MAPS);

export const setIsOpenBaseMapPanel = (isOpen: boolean) =>
  action(MapActionTypes.SET_IS_OPEN_BASE_MAP_PANEL, isOpen);

export const setMapSearchWithExtentZoom = (withExtentZoom: boolean[]) =>
  action(MapActionTypes.SET_MAP_SEARCH_WITH_EXTENT_ZOOM, withExtentZoom);
